<template lang="pug">
  include /mixins
  +b.VALIDATION-OBSERVER(
    ref="validator",
    v-slot="{ valid }",
    tag="form",
  )
    ui-loader(v-if='isLoad')

    +b.g-row(
    )
      +b.g-cell.g-cols--12
        slot(
          name='auth-btn'
        )
    +b.g-row
      +b.g-cell.g-cols--12.tt-space_mt--8
        phone-input(
          :rules="'required|phone'",
          :input-label='labels.phone'
          v-model='form.phone',
          ref='phone'
          name='phone'
          :disabled='false'
        )
      +b.g-cell.g-cols.tt-space_mt--6(
      )
        validation-provider(
          :rules='{ required: { allowFalse: false } }',
          v-slot="{ errors }"
          name='agree_rules'
        )
          +b.d-control-input.--appearance_flexible
            +e.element.INPUT(
              type='checkbox'
              name='accept_rules'
              v-model='accept_rules'
              id='accept_rules'
            )

            +e.LABEL.label--static(
              for='accept_rules'
            )
              +b.ds-caption.--size_md.--color_black.P {{ _('Я подтверждаю, что указанный номер телефона принадлежит мне, и соглашаюсь на обработку моих персональных данных в соответствии с') }} &nbsp;
                +b.tt-link--inline.--styling_default.--black.A(:href='offer', target='_blank')
                  +b.ds-caption--size_md.SPAN {{ _('Политикой конфиденциальности') }}
            +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
    .relative
      +b.non-field-error-label.LABEL(v-if="non_field_errors") {{ non_field_errors[0] }}
    +b.g-row--justify_center
      +b.g-cell.g-cols.tt-space_mt--5.tt-space_pt--4-xl
        token-confirmation-check(
          :token='form.phone'
          :additional-data='{ without_other: true, source: $options.TICKET_PHONE_SOURCE }'
          :action='createBuyer'
        )
          template(#default='{ is_confirmed, sendCode }')
            +b.tt-button--auto.BUTTON(
              type='submit'
              :disabled='isLoad',
              @click.prevent='validate(sendCode)'
            )
              +e.title.P {{ _('Подтвердить номер телефона') }}
    slot(name='register-btn')
</template>
<script>

import {
  AnswerMessage,
} from '@utils/submit'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

import { createBuyer } from '@api/ticket_management.service'

import {
  setCookie,
} from '@utils/cookies'

import { TOTIS_2_BUYER_TOKEN, TOTIS_2_BUYER_ID_TOKEN } from '@/app'
import {
  TICKET_PHONE_SOURCE,
} from '@/consts'

export default {
  name: 'Verify',
  mixins: [FormMixin],
  TICKET_PHONE_SOURCE,
  props: {
    noRedirect: {
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    check: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      labels: {
        phone: this._('Телефон'),
      },
      form: {
        phone: '',
      },
      accept_rules: false,
      isLoad: false,
      non_field_errors: '',
      offer: window.offer,
      rules: window.rules,
      recovery_link: window.recovery_page,
      register_link: window.registration_page,
    }
  },

  methods: {
    async validate(action) {
      const isValid = (await this.$refs.validator.validate())
      if (!isValid) return
      action()
    },
    createBuyer(id_token) {
      const data = {
        ...this.form,
        id_token,
      }
      this.submit(true, data)
    },
    send(data) {
      return createBuyer.execute({ label: this.label }, data)
        .then(res => {
          // window.dataLayer = window.dataLayer || []
          // window.dataLayer.push({ event: 'event_registration_topic' })
          // const message = {
          //   message: {
          //     title: this._('Buyer create success header'),
          //     text: this._('Buyer create success text'),
          //   },
          // }
          // AnswerMessage(message, this)
          this.$emit('success', {
            id_token: res.data.id,
            phone: this.form.phone,
          })
          this.$nextTick(() => {
            this.$refs.validator.$el.reset()
            this.$refs.validator.reset()
            this.form.message = ''
            this.$emit('close')
            this.check()
          })
        })
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      this.$refs.validator.setErrors(parsed)
    },
  },
}
</script>
